module.exports = __webpack_public_path__ + "static/media/furniture-3042835_640.85a6ee0d.jpg";